var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      !!_vm.groupName
        ? _c("PageHeadContainer", {
            attrs: { title: _vm.groupName },
            scopedSlots: _vm._u(
              [
                {
                  key: "icons",
                  fn: function () {
                    return [
                      _vm.archived
                        ? _c("CardInfoChip", {
                            staticClass: "mr-2",
                            attrs: { message: "Archived", gray: "" },
                          })
                        : _vm._e(),
                      _c(
                        "PageHeadIcon",
                        { attrs: { content: _vm.groupLocation } },
                        [_c("LocationIcon", { staticClass: "h-5 w-5" })],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "actions",
                  fn: function () {
                    return [
                      !_vm.archived
                        ? _c(
                            "div",
                            { staticClass: "flex" },
                            [
                              _c("UiButton", {
                                staticClass: "mr-2",
                                attrs: {
                                  variant: "secondary",
                                  buttonText: "Archive",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.$emit("archived")
                                  },
                                },
                              }),
                              _c("GroupConversationProvider", {
                                attrs: {
                                  managers: _vm.managers,
                                  contractors: _vm.contractors,
                                  currentUserRole: _vm.currentUserRole,
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function ({
                                        groupConversationUsers,
                                        participantsExist,
                                      }) {
                                        return [
                                          participantsExist
                                            ? _c("UiButton", {
                                                attrs: {
                                                  buttonText: "Message",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    _vm.conversationModalShown = true
                                                  },
                                                },
                                              })
                                            : _vm._e(),
                                          _c("CreateGroupConversationModal", {
                                            attrs: {
                                              companyId: _vm.companyId,
                                              currentUserId: _vm.currentUserId,
                                              groupConversationUsers:
                                                groupConversationUsers,
                                              projectTitle: _vm.groupName,
                                            },
                                            model: {
                                              value: _vm.conversationModalShown,
                                              callback: function ($$v) {
                                                _vm.conversationModalShown = $$v
                                              },
                                              expression:
                                                "conversationModalShown",
                                            },
                                          }),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  1437628216
                                ),
                              }),
                            ],
                            1
                          )
                        : _c("UiButton", {
                            attrs: {
                              variant: "secondary",
                              buttonText: "Activate",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.$emit("activated")
                              },
                            },
                          }),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              3573550425
            ),
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }